import { connect } from "react-redux";
import * as Redux from "redux";
import StageOne from "./component";

import {
  reportStructureSchemaSelector,
  reportFormatPreviewStringSelector
} from "../../selectors";

import {
  // Structure
  addDimension,
  removeDimension,
  reorderDimension,
  addMetric,
  removeMetric,
  reorderMetric,
  // Format
  editName,
  editFilename,
  editDescription,
  editDelimiter,
  toggleCompressed,
  editDuration
} from "../../actions";

// Properties
const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    format: {
      name: state.reportForm.format.name,
      filename: state.reportForm.format.filename,
      extension: state.reportForm.format.extension,
      delimiter: state.reportForm.format.delimiter,
      compressed: state.reportForm.format.compressed,
      duration: state.reportForm.format.duration,
      description: state.reportForm.format.description,
      preview: reportFormatPreviewStringSelector(state)
    },
    structure: reportStructureSchemaSelector(state),
    next: ownProps.next
  };
};

// Actions
const mapDispatchToProps = (dispatch: Redux.Dispatch<any>): any => {
  return {
    ...Redux.bindActionCreators(
      {
        // Format
        editName,
        editFilename,
        editDescription,
        editDelimiter,
        toggleCompressed,
        editDuration,
        // Structure
        addDimension,
        removeDimension,
        reorderDimension,
        addMetric,
        removeMetric,
        reorderMetric
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StageOne);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/container.ts